import React from 'react';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import ListViewIcon from 'components/Icons/ListViewIcon';
import CardViewIcon from 'components/Icons/CardListIcon';
import { ViewMode } from 'constants/types';

const ToggleView = ({ viewMode, onToggle }) => {
  const handleToggle = mode => {
    if (viewMode !== mode) {
      onToggle(mode);
    }
  };

  return (
    <Box ml={1}>
      <IconButton onClick={() => handleToggle(ViewMode.CARD)}>
        <CardViewIcon style={{ color: viewMode === ViewMode.CARD ? '' : 'grey' }} color='primary' />
      </IconButton>
      <IconButton onClick={() => handleToggle(ViewMode.TABLE)}>
        <ListViewIcon
          style={{ color: viewMode === ViewMode.TABLE ? '' : 'grey' }}
          color='primary'
        />
      </IconButton>
    </Box>
  );
};

export default ToggleView;
